export const DESTROY_APPLICATION_STATE = 'DESTROY_APPLICATION_STATE';
export default () => ({
  type: DESTROY_APPLICATION_STATE,
});
